import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';

const Subscription = ({ profile, subscription, handleUnsubscribe }) => (
  <div className="payment-info">
    <h4>Subscription</h4>

    {subscription.status === 'Canceled' ? (
      <Row>
        <Col sm={4}>
          <label>Status:</label>
        </Col>
        <Col sm={4}>
          <span className="text-green">{subscription.status}</span>
        </Col>
      </Row>
    ) : (
      <div>
        <Row>
          <Col sm={4}>
            <label>Status:</label>
          </Col>
          <Col sm={4}>
            <span className="text-green">{subscription.status}</span>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <label>Current Billing Period:</label>
          </Col>
          <Col sm={4}>
            <span>
              {subscription.billing_period_start_date} -{' '}
              {subscription.billing_period_end_date}
            </span>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <label>Next Bill Date:</label>
          </Col>
          <Col sm={4}>
            <span>{subscription.next_billing_date}</span>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <label>Price:</label>
          </Col>
          <Col sm={4}>
            <span>${subscription.price}USD</span>
          </Col>
        </Row>

        {profile.braintree_subscription_status !== 'canceled' && (
          <div className="actions">
            <Button onClick={handleUnsubscribe}>Cancel Subscription</Button>
          </div>
        )}
      </div>
    )}
  </div>
);

export default Subscription;



// WEBPACK FOOTER //
// src/components/Profile/Subscription.jsx